import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=e68b5674&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=ts"
export * from "./JobCard.vue?vue&type=script&lang=ts"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=e68b5674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68b5674",
  null
  
)

export default component.exports